export const RESET_PASSWORD_START = 'reset-password/reset-password-start';
export const RESET_PASSWORD_SUCCESS = 'reset-password/reset-password-success';
export const ERROR = 'reset-password/reset-password-error';
export const LOGIN_AFTER_CHANGE = 'reset-password/login-after-change';